export default __webpack_public_path__ + "static/media/Fundamentals_Logo.c7cc401e.png";